'use client';
"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Marquee = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const react_use_1 = require("react-use");
const styled_components_1 = __importDefault(require("styled-components"));
const framer_motion_1 = require("framer-motion");
const hooks_1 = require("../../hooks");
const styles_1 = require("../../styles");
const marqueeOptions = {
    speed: .45,
    threshold: 0.014,
    wheelFactor: 1.8,
    dragFactor: 1.2
};
const MarqueeItem = ({ content, speed }) => {
    const item = (0, react_1.useRef)(null);
    const rect = (0, react_1.useRef)(null);
    const x = (0, react_1.useRef)(0);
    const { size: { width, height } } = (0, hooks_1.useDeviceType)();
    const setX = () => {
        if (!item.current || !rect.current)
            return;
        const xPercentage = (x.current / rect.current.width) * 100;
        if (xPercentage < -100)
            x.current = 0;
        if (xPercentage > 0)
            x.current = -rect.current.width;
        item.current.style.transform = `translate3d(${xPercentage}%, 0, 0)`;
    };
    (0, react_1.useEffect)(() => {
        rect.current = item.current.getBoundingClientRect();
    }, [width, height]);
    const loop = (_e) => {
        x.current -= speed.get();
        setX();
    };
    (0, react_use_1.useRafLoop)(loop, true);
    return (0, jsx_runtime_1.jsx)("div", Object.assign({ className: 'item', ref: item }, { children: content }));
};
const springOptions = {
    damping: 40,
    stiffness: 90,
    mass: 5
};
const Marquee = ({ data, options = null }) => {
    var _a;
    const marquee = (0, react_1.useRef)(null);
    const slowDown = (0, react_1.useRef)(false);
    const x = (0, react_1.useRef)(0);
    const w = (0, react_1.useRef)(typeof window !== 'undefined' ? window.innerWidth : 0).current;
    const speed = (0, framer_motion_1.useSpring)((_a = options === null || options === void 0 ? void 0 : options.speed) !== null && _a !== void 0 ? _a : marqueeOptions.speed, springOptions);
    const skewX = (0, framer_motion_1.useTransform)(speed, [-w * 0.25, 0, w * 0.25], [-25, 0, 25]);
    const loop = () => {
        var _a;
        if (slowDown.current || Math.abs(x.current) < marqueeOptions.threshold)
            return;
        x.current *= 0.66;
        x.current = x.current < 0 ? Math.min(x.current, 0) : Math.max(x.current, 0);
        speed.set(((_a = options === null || options === void 0 ? void 0 : options.speed) !== null && _a !== void 0 ? _a : marqueeOptions.speed) + x.current);
    };
    (0, react_use_1.useRafLoop)(loop, true);
    return ((0, jsx_runtime_1.jsxs)(Div, Object.assign({ className: 'marquee', ref: marquee, style: { skewX } }, { children: [(0, jsx_runtime_1.jsx)(MarqueeItem, { content: data, speed: speed }), (0, jsx_runtime_1.jsx)(MarqueeItem, { content: data, speed: speed }), (0, jsx_runtime_1.jsx)(MarqueeItem, { content: data, speed: speed }), (0, jsx_runtime_1.jsx)(MarqueeItem, { content: data, speed: speed }), (0, jsx_runtime_1.jsx)(MarqueeItem, { content: data, speed: speed })] })));
};
exports.Marquee = Marquee;
const Div = (0, styled_components_1.default)(framer_motion_1.motion.div) `
  align-items: center;
  display: flex;

  .item {
    ${(0, styles_1.getP93)()}
    align-items: center;
    color: ${({ theme }) => theme.colors.creme};
    display: flex;
    height: 100px;
    padding: ${(0, styles_1.vw)(20, 'mobile')} 0;
    padding-right: 0 !important;
    width: auto;
    white-space: nowrap;

    ${styles_1.mq.greaterThan('nexus7')} {
      padding: ${(0, styles_1.vw)(20, 'nexus7')} 0;
    }

    ${styles_1.mq.greaterThan('tablet')} {
      padding: ${(0, styles_1.vw)(40, 'desktop')} 0;
    }

    ${styles_1.mq.greaterThan('desktop')} {
      padding: 40px 10px;
    }

    &:after {
      content: '·';
      display: inline-block;
      padding: 0 ${(0, styles_1.vw)(30, 'mobile')};
      width: fit-content;

      ${styles_1.mq.greaterThan('nexus7')} {
        padding: 0 ${(0, styles_1.vw)(30, 'nexus7')};
      }

      ${styles_1.mq.greaterThan('tablet')} {
        padding: 0 ${(0, styles_1.vw)(30, 'desktop')};
      }

      ${styles_1.mq.greaterThan('desktop')} {
        padding: 30px;
      }
    }
  }

  ul {
    display: flex;
  }
`;
